import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 6h18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 12h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 18h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListFilter";
const ListFilter = memo(themed(Icon));
export {
  ListFilter
};
//# sourceMappingURL=list-filter.js.map
